// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2DoME","item":"styles_item__108sd","text":"styles_text__2I3yb"};